module.exports = __webpack_public_path__ + "c_static/img/1-1手机淘宝购物车.df1a89f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/4-回购特卖入口/1-1手机淘宝购物车.jpg
// module id = /Ul8
// module chunks = 33